'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EducationModel = function () {
  function EducationModel(data) {
    _classCallCheck(this, EducationModel);

    this.logentries = [];
    this.person = null;
    this.location = null;
    this.values = {
      id: null,
      person_id: null,
      location_id: null,
      title: null,
      start: null,
      end: null
    };

    window.PRIM.modelMapper.mapToModel(data, this.values);
  }

  _createClass(EducationModel, [{
    key: 'getTitle',
    value: function getTitle() {
      return [this.values.title].join(' ');
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      var title = [];

      if (this.location) {
        if (this.location.values.business) {
          title.push(this.location.values.business);
        }

        if (this.location.values.visitcity) {
          title.push(this.location.values.visitcity);
        }

        if (this.location.organisation && this.location.organisation.values.name) {
          title.push(this.location.organisation.values.name);
        }
      }

      return title.join(' ');
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      var image = null;

      if (this.person && this.person.getImage) {
        image = this.person.getImage();
      }

      if (!image && this.location && this.location.getImage) {
        image = this.location.getImage();
      }

      return image;
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      if (this.getCompareString()) {
        return this.getCompareString().substring(0, 1).toUpperCase();
      }

      return null;
    }
  }, {
    key: 'getCompareString',
    value: function getCompareString() {
      var title = [];

      if (this.values.title) {
        title.push(this.values.title);
      }

      if (this.location) {
        if (this.location.values.business) {
          title.push(this.location.values.business);
        }

        if (this.location.values.visitcity) {
          title.push(this.location.values.visitcity);
        }

        if (this.location.organisation && this.location.organisation.values.name) {
          title.push(this.location.organisation.values.name);
        }
      }

      return title.join(' ');
    }
  }, {
    key: 'getJSON',
    value: function getJSON() {
      var result = {};

      window.PRIM.modelMapper.mapToObject(this.values, result);

      return result;
    }
  }]);

  return EducationModel;
}();

exports.default = EducationModel;


//////////////////
// WEBPACK FOOTER
// ./js/modules/education/model/EducationModel.js
// module id = 9
// module chunks = 0